<template>
  <div
    class="cyber xl:tw-flex tw-bg-[#0345BD] tw-rounded-md tw-p-[20px] tw-items-center"
    style="border: 1px solid var(--Brand-Azure, #0345bd)"
  >
    <div
      v-if="img"
      class="tw-flex tw-px-[32px] tw-py-[7px] tw-bg-[#d9edff] tw-rounded-md tw-mr-[25px] tw-max-w-[160px] cyber__logo"
    >
      <img :src="img" alt="logo" class="tw-w-full tw-h-full" />
    </div>
    <div
      class="tw-text-[#fff] tw-flex tw-flex-col tw-justify-center tw-gap-[8px]"
    >
      <div class="tw-text-[16px] tw-font-semibold tw-leading-[21px]">
        {{ data?.item?.title }}
      </div>
      <div
        v-if="description"
        class="tw-text-[13px] tw-font-normal tw-leading-[17px]"
      >
        <customDescriptionContent
          :description="description"
          :custom-class="'!tw-p-[0px] tw-text-[#fff]'"
          :is-recommendation="true"
        ></customDescriptionContent>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, Ref, watch } from "vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";
const props = defineProps({
  data: {
    type: Object as () => any,
    required: true,
  },
});

const img: Ref<any> = ref("");
const description: Ref<any> = ref("");

onMounted(() => {
  parseDescription();
});

const parseDescription = () => {
  const checklistGroupDescription =
    props.data?.item?.checklistGroupDescription || "";
  try {
    const descriptions = JSON.parse(checklistGroupDescription);
    if (descriptions?.image) {
      const startChar = descriptions?.image.slice(0, 2);
      img.value = `data:image/${
        startChar !== "iV" ? "svg+xml" : "png"
      };base64,${descriptions?.image}`;
    }
    description.value = descriptions?.description;
  } catch (e) {
    description.value = checklistGroupDescription;
  }
};

watch(
  () => props.data,
  () => {
    parseDescription();
  },
);
</script>
<style scoped>
@media only screen and (max-width: 1280px) {
  .cyber__logo {
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
